// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"131":"19ba8e8f","201":"9aae52cb","787":"447038b5"}[chunkId] + ".chunk.js";
};